module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_data03-sp-246de134a1daef9432e894ec60c63c8a.png";